import { v1ApiClient } from '@/services';
import type { PathParams, RequestBody, ResponseBody } from '@/shared/api/generated';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

type SignalPath = '/v1/workspaces/{workspace_id}/signals/{signal_id}';

type UpdateSignalParams = Partial<Pick<PathParams<SignalPath, 'put'>, 'workspace_id'>> &
  Pick<PathParams<SignalPath, 'put'>, 'signal_id'> &
  RequestBody<SignalPath, 'put'>;
type UpdateSignalResponse = ResponseBody<SignalPath, 'put'>;
type UpdateSignalFunction = (
  params: UpdateSignalParams,
) => Promise<UpdateSignalResponse>;

/**
 * Signal 수정
 */
export const updateSignal: UpdateSignalFunction = ({
  workspace_id,
  signal_id,
  title,
  definition,
}) => {
  const wa = workspace_id ?? getCurrWorkspaceAlias();
  return v1ApiClient
    .put(`/workspaces/${wa}/signals/${signal_id}`, { title, definition })
    .then((res) => res.data);
};
